import { TabsName } from "../_types/tabsName";

export const PRIVACY_TABS_TITLES: TabsName[] = [
  "camera",
  "mail",
  "drive",
  "message",
];
